import TraditionalComparison from "@/components/comparisonWithTraditional";
import { COMPARISON_CONSTANTS_NETWORK_DESIGN } from "./constants";

const ComparisonComp = () => {
  return <TraditionalComparison {...COMPARISON_CONSTANTS_NETWORK_DESIGN} />;
};

export default ComparisonComp;
